'use strict'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import DashboardItem from './../common/DashboardItem'

class Dashboard extends Component {

    componentDidMount() {
        var self = this
        self.props.actions.getStats(self.props.params.appCodename)
    }

    render() {
        var self = this
        var content = null
        if (self.props.stats) {
            var dashboardItems = []
            dashboardItems.push(
                <DashboardItem
                    key='transactionsPaid'
                    count={ self.props.stats.transactionsPaid }
                    icon='fa-credit-card'
                    name={ 'Transacciones pagadas' }
                    color='green'
                    selected={'/manager/' + self.props.params.appCodename + '/transactions?status=paid'}
                />
            )
            dashboardItems.push(
                <DashboardItem
                    key='transactionsPending'
                    count={ self.props.stats.transactionsPending }
                    icon='fa-credit-card'
                    name={ 'Transacciones pendientes' }
                    color='yellow'
                    selected={'/manager/' + self.props.params.appCodename + '/transactions?status=pending'}
                />
            )
            dashboardItems.push(
                <DashboardItem
                    key='transactionsRejected'
                    count={ self.props.stats.transactionsRejected }
                    icon='fa-credit-card'
                    name={ 'Transacciones rechazadas' }
                    color='red'
                    selected={'/manager/' + self.props.params.appCodename + '/transactions?status=rejected'}
                />
            )
            dashboardItems.push(
                <DashboardItem
                    key='entity'
                    count={ self.props.stats.entity }
                    icon='fa-university'
                    name={ 'Entidades' }
                    color='primary'
                    selected={'/manager/' + self.props.params.appCodename + '/entity'}
                />
            )
            dashboardItems.push(
                <DashboardItem
                    key='subscriptions'
                    count={ self.props.stats.subscriptionsApproved }
                    icon='fa-handshake-o'
                    name={ 'Subscripciones aprobadas' }
                    color='mt-color-facebook'
                    selected={'/manager/' + self.props.params.appCodename + '/subscriptions'}
                />
            )

            if (dashboardItems && dashboardItems.length) {
                content = dashboardItems.map(function(dashboardItem) {
                    return dashboardItem
                })
            }
        }
        return (
            <div>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h1 className='page-header'>Inicio</h1>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-12'>
                        { content }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        stats: state.stats,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Dashboard)



// WEBPACK FOOTER //
// ./components/Dashboard/index.js